/**
 * Leadership briefing access — any Top Customer with a Salesforce ACCOUNT_ID.
 * Keep in sync with: server/services/customerBriefing/access.js
 */

/** Salesforce ACCOUNT_IDs for Clifford Chance (primary + secondary). Curated-pack reference only. */
export const CLIFFORD_CHANCE_ACCOUNT_IDS = Object.freeze([
  '0011B00002CbVpIQAV',
  '0014O00002MGctqQAD'
]);

/** Fixed link name that always opens the Clifford Chance briefing (/briefings/clifford-chance). */
export const CLIFFORD_CHANCE_BRIEFING_SLUG = 'clifford-chance';

const normalizeAccountIds = (...sources) => {
  const out = [];
  const seen = new Set();
  const push = (value) => {
    const id = String(value || '').trim();
    if (!id || seen.has(id)) return;
    seen.add(id);
    out.push(id);
  };
  for (const source of sources) {
    if (Array.isArray(source)) source.forEach(push);
    else if (source != null && source !== '') push(source);
  }
  return out;
};

/** URL form of an admin account name: "Clifford Chance LLP" -> "clifford-chance-llp". Mirrors the server. */
export const slugifyName = (name) => String(name || '')
  .normalize('NFKD')
  .toLowerCase()
  .replace(/[^a-z0-9]+/g, '-')
  .replace(/^-+|-+$/g, '');

/**
 * Briefing page gate: any customer with at least one ACCOUNT_ID. The section builds the href from
 * the admin account name (slugifyName); this only decides whether the card shows.
 * Returns a non-null token when enabled (legacy callers treat truthy as “show”).
 */
export const briefingSlugForAccountIds = (...sources) => (
  normalizeAccountIds(...sources).length > 0 ? 'enabled' : null
);
